// project import
import home from './home';
import messagesDashboard from './message-center';
import dataAnalytics, { dataAnalyticsForFlags } from './data-analytics';
import marketIntelligence from './market-intelligence';
import shopHealth from './shop-health';
import businessStrategy from './business-strategy';
import support from './support';
import settings from './settings';
import { crm } from './crm';
import { collaborations } from './collaborations';
import { video } from './video-ai';
import { affiliateCommunity, simplifiedAffiliateCommunity } from './affiliate-community';
import { SHOW_COMMISSION_OPTIMIZER } from 'constants/waffleConstants';

// types
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

import type { ShopPerformanceScore } from 'model/types/shop-performance';

// ==============================|| MENU ITEMS ||============================== //

const allMenuItems: { items: NavItemType[] } = {
  items: [
    home,
    affiliateCommunity,
    collaborations,
    crm,
    messagesDashboard,
    marketIntelligence,
    dataAnalytics,
    shopHealth,
    video,
    businessStrategy,
    simplifiedAffiliateCommunity,
    support,
    settings
  ]
};

export function getMenuItems({
  shopPerformanceScore,
  hasTiktokShopFeature,
  flags = []
}: Readonly<{ shopPerformanceScore: ShopPerformanceScore | null; hasTiktokShopFeature: boolean; flags?: string[] }>): {
  items: NavItemType[];
} {
  return {
    items: allMenuItems.items
      .filter((item) => shopPerformanceScore !== null || item !== shopHealth)
      .filter((item) => hasTiktokShopFeature || item !== marketIntelligence)
      .filter((item) => flags.includes(SHOW_COMMISSION_OPTIMIZER) || item !== businessStrategy)
      .map((item) => (item === dataAnalytics ? dataAnalyticsForFlags(flags) : item))
  };
}

export default allMenuItems;
